import type { Capability, ConnectwareError, PaginatedData } from '../../../../domain'

import type {
    PageSubscriptionsTypes,
    SingleSubscriptionsTypes,
    SubscriptionFilterArgs,
    SubscriptionPageEvent,
    SubscriptionPageOptions,
} from '../../../../application'

export interface SubscriptionStrategy<P extends keyof PageSubscriptionsTypes, S extends keyof SingleSubscriptionsTypes> {
    readonly requiredPermissions: readonly Capability[]

    readonly supportsPagination: boolean

    supportsFilters(filter: SubscriptionFilterArgs): boolean

    createAllChangeListener?(filter: SubscriptionFilterArgs, handler: VoidFunction): Promise<VoidFunction>
    createSingleChangeListener?(id: string, handler: VoidFunction): Promise<VoidFunction>
    createCountChangeListener?(handler: VoidFunction): Promise<VoidFunction>

    retrievePage(args: SubscriptionFilterArgs & SubscriptionPageOptions<P>): Promise<PaginatedData<PageSubscriptionsTypes[P]>>
    retrieveAll(filter: SubscriptionFilterArgs): Promise<PageSubscriptionsTypes[P][]>
    retrieveOne(id: string): Promise<SingleSubscriptionsTypes[S]>
    retrieveCount(): Promise<number>

    compareAll(oldResults: PageSubscriptionsTypes[P][] | ConnectwareError, newResults: PageSubscriptionsTypes[P][] | ConnectwareError): boolean
    compareOne(oldResult: SingleSubscriptionsTypes[S] | ConnectwareError, newResult: SingleSubscriptionsTypes[S] | ConnectwareError): boolean
    comparePage(oldPage: SubscriptionPageEvent<P>, newPage: SubscriptionPageEvent<P>): boolean
}
